<template>
  <div class="campaign-performance">
    <div class="py-4">
      <div class="row">
        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">Total Spend</h6>
            <h2 class="fw-bold text-center">$9,500</h2>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">
              Cost per Click
            </h6>
            <h2 class="fw-bold text-center">$8.5</h2>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">
              Cost per Application
            </h6>
            <h2 class="fw-bold text-center">$17.5</h2>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">ROI(Avg.)</h6>
            <h2 class="fw-bold text-center">87%</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="card p-3">
            <h6 class="text-muted mb-2 text-uppercase">ROI</h6>
            <div>
              <LineApex1 />
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card p-3">
            <h6 class="text-muted mb-2 text-uppercase">
              campaign spend vs results
            </h6>
            <div>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Campaign Date</th>
                    <th scope="col">Campaign Spend</th>
                    <th scope="col">Conversion(%)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Apr/2025</td>
                    <td>$8200</td>
                    <td>82%</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>May/2025</td>
                    <td>$8000</td>
                    <td>81%</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Jun/2025</td>
                    <td>$7500</td>
                    <td>83%</td>
                  </tr>
                  <tr>
                    <th scope="row">4</th>
                    <td>Jul/2025</td>
                    <td>$9100</td>
                    <td>87%</td>
                  </tr>
                  <tr>
                    <th scope="row">5</th>
                    <td>Aug/2025</td>
                    <td>$8700</td>
                    <td>85%</td>
                  </tr>
                  <tr>
                    <th scope="row">6</th>
                    <td>Sep/2025</td>
                    <td>$8000</td>
                    <td>78%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import DonutApex from "@/components/reusable/Charts/Apex/DonutApex.vue";
import BarApex from "@/components/reusable/Charts/Apex/BarApex.vue";
import LineApex1 from "@/components/reusable/Charts/Apex/LineApex1.vue";

export default {
  name: "CampaignROI",
  components: {
    BasicBar,
    LineApex1,
    DonutApex,
    BarApex,
  },
  data() {
    return {
      openAndClickRatesData: [
        {
          name: "Open Rate",
          borderColor: "#5478AF",
          backgroundColor: "#5478AF",
          values: [
            { name: "Campaign 1", value: 100 },
            { name: "Campaign 2", value: 200 },
            { name: "Campaign 3", value: 350 },
            { name: "Campaign 4", value: 500 },
            { name: "Campaign 5", value: 650 },
            { name: "Campaign 6", value: 800 },
          ],
        },
        {
          name: "Click Rate",
          borderColor: "#25436D",
          backgroundColor: "#25436D",
          values: [
            { name: "Campaign 1", value: 200 },
            { name: "Campaign 2", value: 100 },
            { name: "Campaign 3", value: 320 },
            { name: "Campaign 4", value: 450 },
            { name: "Campaign 5", value: 500 },
            { name: "Campaign 6", value: 650 },
          ],
        },
      ],
      funnelChartData: [
        {
          name: "Total Reach",
          value: 500,
        },
        {
          name: "Total Clicks",
          value: 400,
        },
        {
          name: "Total Applications Started",
          value: 350,
        },
        {
          name: "Total Applications Completed",
          value: 250,
        },
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        animation: {
          duration: 0,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: false,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: true,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: "#fff",
            anchor: "end",
            align: "start",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value) => value,
          },
        },
      },
      campaignContributionData: [
        {
          name: "Total Reach",
          value: 500,
          backgroundColor: "#4971AB",
        },
        {
          name: "Total Clicks",
          value: 400,
          backgroundColor: "#25436D",
        },
      ],
      pieOptions: {
        maintainAspectRatio: false,
        animation: {
          duration: 0, // Disable all animations
        },
        legend: {
          display: false,
        },
      },
      defaultDatasets: [
        {
          backgroundColor: ["#25436D", "#4971AB"],
          data: [500, 400],
          label: "Total Reach",
          hoverOffset: 10,
        },
      ],
      labels: ["Total Reach", "Total Clicks"],
    };
  },
};
</script>
<style scoped>
.card {
  border: none;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.funnel {
  background: linear-gradient(to bottom, #1e3a8a, #2563eb);
  border-radius: 16px;
  color: #ffffff;
  text-align: center;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  min-height: 400px;
}

.funnel-step {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.4);
  margin: 0.5rem 0;
}
.chart-container {
  height: 200px;
}
.donut-chart {
  height: 250px;
}
</style>
